import React, { Component } from "react";
import './HeSi.css';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import { Result, Button } from 'antd';

export class HeSi extends Component {
    constructor(props) {
        super(props);      
    };
    async beforeSubmit(e){
        e.preventDefault();
        const urlParams = new URLSearchParams(window.location.search);
        var tenantId = urlParams.get("tenantId");
        var userId = urlParams.get("userId");
        var applyId=urlParams.get("applyId");
        var btn=document.getElementById("submit");
        var PICAOpt=document.getElementById("PICA");
        var PIBAOpt=document.getElementById("PIBA");
        var PIBACAOpt=document.getElementById("PIBACA");
        var msgbox=document.getElementById("msg");
        var code=null;
        var message="";
        var errMessage="";
        if(PIBAOpt.selected){
            //选择PIBA的情况
            btn.disabled=true;
            btn.value="正在发起测评...";
            await axios.post(`/api/HeSi_PI/createPIBATest?tenantId=${tenantId}&userId=${userId}&applyId=${applyId}`).then(res => {
                code=res.data.code;
                message=res.data.data;
                errMessage=res.data.message;
            });
            if (code == "200") {
                //alert(`message:${res.data.message}\ndata:${res.data.data}`);
                window.parent.postMessage(
                    {
                      msgCode: 'ext-btn-modal-msg',
                      Code: 200,
                      Message: message,
                      isClose: true,//这个参数控制是否关闭，默认为true
                    },
                    '*'
                );
                return;
            }
            else {
                //alert(`message:${res.data.message}\ndata:${res.data.data}`);
                msgbox.innerHTML=errMessage;
                btn.disabled=false;
                btn.value="发起测评";
                return;
            }
        }else if(PICAOpt.selected){
            //选择PICA的情况
            btn.disabled=true;
            btn.value="正在发起测评...";
            await axios.post(`/api/HeSi_PI/createPICATest?tenantId=${tenantId}&userId=${userId}&applyId=${applyId}`).then(res => {
                code=res.data.code;
                message=res.data.data;
                errMessage=res.data.message;
            });
            if (code == "200") {
                //alert(`message:${res.data.message}\ndata:${res.data.data}`);
                window.parent.postMessage(
                    {
                      msgCode: 'ext-btn-modal-msg',
                      Code: 200,
                      Message: message,
                      isClose: true,//这个参数控制是否关闭，默认为true
                    },
                    '*'
                );
                return;
            }
            else {
                //alert(`message:${res.data.message}\ndata:${res.data.data}`);
                msgbox.innerHTML=errMessage;
                btn.disabled=false;
                btn.value="发起测评";
                return;
            }
        }else if(PIBACAOpt.selected){
                var isAllOK=true;
                //选择PICA的情况
                btn.disabled=true;
                btn.value="正在发起测评...";
                await axios.post(`/api/HeSi_PI/createPICATest?tenantId=${tenantId}&userId=${userId}&applyId=${applyId}`).then(res => {
                    code=res.data.code;
                    if (code != "200") {
                        errMessage="CA测评："+res.data.message+"。";
                        isAllOK=false;
                    }else{
                        message="CA测评："+res.data.data+"。";
                    }
                });
                
                //选择PIBA的情况
                await axios.post(`/api/HeSi_PI/createPIBATest?tenantId=${tenantId}&userId=${userId}&applyId=${applyId}`).then(res => {
                    code=res.data.code;
                    if (code != "200") {
                        errMessage+="BA测评："+res.data.message+"。";
                        isAllOK=false;
                    }else{
                        message+="BA测评："+res.data.data+"。";
                    }
                });
                
                if(!isAllOK){
                    msgbox.innerHTML=errMessage+"<br>"+message;
                    btn.disabled=false;
                    btn.value="发起测评";
                    return;
                }else{
                    window.parent.postMessage(
                        {
                          msgCode: 'ext-btn-modal-msg',
                          Code: 200,
                          Message: message,
                          isClose: true,//这个参数控制是否关闭，默认为true
                        },
                        '*'
                    );
                    return;
                }
        }
    };
    render() {
        return (
            <form id="testForm" onSubmit={this.beforeSubmit}>
                <p>
                    <label>请选择测评类型：</label>
                    <select id="testType">
                        <option id="PIBACA">PIBA和PICA</option>
                        <option id="PICA">PICA</option>
                        <option id="PIBA">PIBA</option>
                    </select>
                </p>
                <p>
                    <input id="submit" type="submit" value="发起测评"/>
                </p>
                <p>
                    <label id="msg" style={{color: 'red'}}></label>
                </p>
            </form>
        );
    }
}
